import React, { PureComponent } from "react";
import Navbar from "../NavBar/NavBar";
import "../../StylesPages/dashboard.css";
import { EventsPerMonths } from "../Analytics/EventsPerMonths";
import MatchedUserParSecteur from "../Analytics/MatchedUserParSecteur";
import MatchedUsers from "../Analytics/MatchedUsers";
import NewCandidatForOffer from "../Analytics/NewCandidatForOffer";
import ProfileVisit from "../Analytics/ProfileVisit";
import { Box, Button, Center, Flex, Text } from "@chakra-ui/react";
import { Image } from "@chakra-ui/react";

export class DashBoard extends PureComponent {
  render() {
    document.body.style = "background: #FFFFFF;";
    const height = "100%";
    const width = "20%";

    return (
      <>
        <div className="dashboard-container">
          <Navbar />
          <div className="dashboard-content">
            <Text
              fontFamily={"Sofia pro"}
              fontSize={"5xl"}
              fontWeight={"bolder"}
              marginStart={["10px", "10px", "80px", "80px"]}
            >
              Tableau de bord
            </Text>
            <Center>
              <Flex
                w={"100%"}
                px={[0, 0, 10, 10]}
                py={[0, 0, 5, 5]}
                spacing={200}
                direction={{ base: "column", md: "row" }}
              >
                <Box
                  width={["100%", "100%", "40%", "40%"]}
                  display={"grid"}
                  placeItems={["center", "center", "start", "start"]}
                >
                  <Box
                    display={"grid"}
                    placeItems={["center", "center", "start", "start"]}
                  >
                    <Text
                      fontFamily={"Sofia Pro"}
                      fontSize={"24px"}
                      fontWeight={900}
                      marginStart={["-35%", "-35%", "50px", "50px"]}
                    >
                      Votre forfait
                    </Text>
                    <Image
                      src="pack pro petit.png"
                      marginStart={["0px", "0px", "10px", "10px"]}
                    />

                    <Text
                      fontFamily={"Sofia Pro"}
                      fontWeight={"normal"}
                      align={["center", "center", "left", "left"]}
                      w="80%"
                      letterSpacing={0.1}
                      lineHeight={1.1}
                      ml={[0, 0, 5, 5]}
                    >
                      Si vous avez une question sur votre abonnement
                      ouconcernant un autre sujet, il vous faudra remplir un
                      formulaire afin que nous puissions traiter votre demande
                      sous les plus brefs délais.
                    </Text>
                    <Button
                      backgroundColor={"#0080ff"}
                      borderRadius={"100px"}
                      my="30px"
                      px={14}
                      
                      color="white"
                      marginStart={["0px", "0px", "50px", "50px"]}
                    >
                      Poser une question
                    </Button>
                  </Box>
                </Box>

                <Box width={["100%", "100%", "33%", "33%"]} p={4}>
                  <Box
                    bg="#d4eeff"
                    borderRadius={"20px"}
                    align="center"
                    h={"max-content"}
                    maxH={"450px"}
                    p={4}
                    marginBottom="20px"
                  >
                    <Text
                      fontFamily={"Sofia Pro"}
                      fontSize={["xl", "xl", "2xl", "2xl"]}
                      fontWeight={"bold"}
                      align="left"
                    >
                      Nombre de matchings par mois
                    </Text>
                    <MatchedUsers></MatchedUsers>
                  </Box>

                  <Box
                    bg="#d4eeff"
                    borderRadius={"20px"}
                    align="center"
                    h={"max-content"}
                    maxH={"250px"}
                    marginBottom="20px"
                  >
                    <Text
                      fontFamily={"Sofia Pro"}
                      fontSize={"2xl"}
                      fontWeight={"bold"}
                      align="left"
                      p={4}
                    >
                      Nombre de visites par mois
                    </Text>
                    <ProfileVisit></ProfileVisit>
                  </Box>
                </Box>
                <Box width={["100%", "100%", "27%", "27%"]} p={4}>
                  <Box
                    bg="#d4eeff"
                    borderRadius={"20px"}
                    align="center"
                    maxH={"320px"}
                    h={"320px"}
                    marginBottom="20px"
                  >
                    <NewCandidatForOffer></NewCandidatForOffer>
                  </Box>
                  <Box
                    bg="#d4eeff"
                    borderRadius={"20px"}
                    align="center"
                    h={"max-content"}
                    maxH={"380px"}
                  >
                    <Text
                      fontFamily={"Sofia Pro"}
                      fontSize={"24px"}
                      fontWeight={"bold"}
                      align="left"
                      p={4}
                      ms={"30px"}
                    >
                      Nombre d’évènements par mois
                    </Text>
                    <EventsPerMonths></EventsPerMonths>
                  </Box>
                  {/* <Box bg="#d4eeff" borderRadius={"20px"} align="center">
                    <Text fontFamily={"Sofia Pro"} fontSize={"2xl"} fontWeight={"bold"} align="center">
                      Nombre de candidatures
                    </Text>
                    <MatchedUserParSecteur></MatchedUserParSecteur>
                  </Box> */}
                </Box>
              </Flex>
            </Center>
          </div>
        </div>
      </>
    );
  }
}

export default DashBoard;
